import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { Tooltip, TooltipDirection } from 'components/Tooltip';
import { useStore } from 'hooks/useStore';
import { ReactNode } from 'react';

export const CopyToClipboard = ({
	children,
	value,
	primary,
	small,
	outline,
	ghost,
	ghostPrimary,
	square,
	tooltipDirection,

	isInfoBlock,
}: {
	children: ReactNode;
	value?: string;
	primary?: boolean;
	small?: boolean;
	outline?: boolean;
	ghost?: boolean;
	ghostPrimary?: boolean;
	square?: boolean;
	tooltipDirection?: TooltipDirection;

	isInfoBlock?: boolean;
}) => {
	const { notifications } = useStore();

	return (
		<Tooltip
			content="Zkopírovat odkaz"
			direction={tooltipDirection ? tooltipDirection : TooltipDirection.TOP}
		>
			{!isInfoBlock && (
				<Button
					small={small}
					primary={primary}
					outline={outline}
					ghost={ghost}
					ghostPrimary={ghostPrimary}
					square={square}
					onClick={(e) => {
						navigator.clipboard.writeText(value);
						e.preventDefault();
						e.stopPropagation();

						notifications.addNotification({ message: 'Zkopirovano' });
					}}
				>
					{children}
				</Button>
			)}

			{isInfoBlock && (
				<div
					css={css`
						border: 1px solid #f1f1f4;
						background: #fafaff;
						border-radius: 12px;
						padding: 8px 12px;
						font-size: 13px;
						line-height: 20px;
					`}
					onClick={(e) => {
						navigator.clipboard.writeText(value);
						e.preventDefault();
						e.stopPropagation();

						notifications.addNotification({ message: 'Zkopirovano' });
					}}
				>
					{children}
				</div>
			)}
		</Tooltip>
	);
};
